/* eslint-disable */
import React from 'react';
import Pagination, { bootstrap5PaginationPreset } from 'react-responsive-pagination';

const PageInfo = ({ pageInfo, handlePaging }) => {
  // 💡 안전장치: pageInfo가 없거나 아직 로딩 중일 때 예외 처리
  if (!pageInfo || pageInfo.totalPages === 0) return null;

  // 부모가 준 pageInfo.number(0부터 시작)를 1부터 시작하는 페이지로 변환
  const activePage = (pageInfo.number ?? 0) + 1;
  const totalPages = pageInfo.totalPages ?? 1;

  return (
    <div style={{ maxWidth: "1000px", margin: "auto" }}>
      <Pagination
        {...bootstrap5PaginationPreset}
        current={activePage}          // 💡 내부 state 대신 직접 계산된 값 주입
        total={totalPages}
        onPageChange={handlePaging}
      />
    </div>
  );
}

export default PageInfo;